import React from 'react';
import PropTypes from 'prop-types';

import styles from './title.module.scss';

const Title = ({ children, total }) => {
  return (
    <h1 className={styles.title}>
      <span>
        <span className={styles.titleSpan}>{children}</span>
        {total !== null && total !== undefined && (
          <span className={styles.titleSpan2}>{total}</span>
        )}
      </span>
    </h1>
  );
};

Title.propTypes = {
  children: PropTypes.node.isRequired,
  total: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

Title.defaultProps = {
  total: null,
};

export default Title;
